import Slide from '@material-ui/core/Slide';
import React from 'react';

const Transition = (props, ref) => <Slide direction="down" {...props} ref={ref} />;

export default React.forwardRef(Transition);
